module.exports = __webpack_public_path__ + "static/media/timeicon.8c0694a0.svg";